import type {ReactElement} from 'react';
import React from 'react';
import {AiTextPromptBox} from '@Components/ai-text-prompt-box';
import {useDispatch} from 'react-redux';
import {closePanel} from '@Components/panel/panel-reducer';
import useCustomPanelClose from '@Panels/hooks/useCustomPanelClose';
import {PANEL_ID} from '@Panels/ai-text-prompt-box-panel/ai-text-prompt-box-panel.types';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AiTextPromptBoxProps} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

type AiTextPromptBoxPanelProps = AiTextPromptBoxProps;

export function AiTextPromptBoxPanel({...props}: AiTextPromptBoxPanelProps): ReactElement<any> {
  const dispatch = useDispatch();

  const close = (): void => {
    props.onBack?.();
    dispatch(closePanel(PANEL_ID));
    dispatch(closeModal(MODALS_IDS.AI_TEXT_PROMPT_BOX_MODAL));
  };

  const onCloseAiTextPromptBoxPanel = useCustomPanelClose(PANEL_ID, close);

  const mergedProps: AiTextPromptBoxProps = {
    ...props,
    onBack: onCloseAiTextPromptBoxPanel,
  };

  return <AiTextPromptBox {...mergedProps} />;
}
